import { render, staticRenderFns } from "./duo_chat_state_manager.vue?vue&type=template&id=9849216c"
import script from "./duo_chat_state_manager.vue?vue&type=script&lang=js"
export * from "./duo_chat_state_manager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports